import React from 'react';
import styled from '@emotion/styled';
import { config } from '../../../config';
import { __, TranslationService } from '../../../helpers/TranslationService';
import { ICabinInfo } from '../../../interfaces';

const StyledCardContainer = styled.div`
    background-color: rgba(22, 78, 120, 0.06);
    padding: 20px;

    img {
        border-radius: 50%;
        margin-right: 20px;
    }

    small {
        font-size: 11px;
        color: #7d7d7d;
        font-weight: normal;
    }
`;

const StyledCardTitle = styled.p`
    margin-bottom: 12px;
    font-weight: 700;
    font-size: 12px;
    color: #333333;
`;

const StyledPhoneContainer = styled.div`
    display: flex;
    align-items: center;
`;

const StyledPhone = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: bold;
    color: #00233b;
`;

interface IProps {
    cabin?: ICabinInfo;
    phoneNumber?: string;
    officeHours?: {
        firstLine?: string;
        secondLine?: string;
    };
}

export const CruiseInquiryPhoneCard = ({ phoneNumber, officeHours, cabin }: IProps) => {
    const isPriceValid = cabin?.cabinType?.price?.valid;

    if (!isPriceValid || !phoneNumber) {
        return null;
    }

    return (
        <StyledCardContainer className="callExpert-card">
            <StyledCardTitle>
                {__(
                    'Dont want to look yourself? Let our cruise experts give you the best advice!',
                    'dreamlines',
                )}
            </StyledCardTitle>

            <StyledPhoneContainer>
                <img
                    src={`${config.images}/common/call-cruise-expert.png`}
                    alt={`${__('Professional, expert advice', 'dreamlines')}`}
                />
                <StyledPhone>
                    <span className="icon-handset-rounded"> {phoneNumber} </span>
                    {officeHours?.firstLine && <small> {officeHours.firstLine} </small>}
                </StyledPhone>
            </StyledPhoneContainer>
        </StyledCardContainer>
    );
};
